import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Badge,
} from "reactstrap";

import { Chart as ChartJS, registerables } from "chart.js";

import Breadcrumbs from "../../components/Common/Breadcrumb";
import WelcomeComp from "./WelcomeComp/WelcomeComp";
import Reservation from "./Reservation";
import axios from "axios";
import Sarabun from "./Sarabun/Sarabun";
import { GetCookieData, GetCookieToken } from "../Cookie/GetCookie";
import ResorceOnline from "./ResorceOnline/ResorceOnline";
import FadeIn from "react-fade-in/lib/FadeIn";
import LoadingPage from "../TESTPage/LoadingPage";
import classnames from "classnames";
import WorkEntry from "../EntryWork/WorkEntry";
import { CheckBudgetYear } from "../Function/CheckBudgetYear";
import { useGetPositionConText } from "../Context/PositionContext";
import { useGetPositionSubAdminConTextConText } from "../Context/PositionSubAdminConText";

ChartJS.register(...registerables);

const Dashboard = () => {
  const baseURL = process.env.REACT_APP_API_CORS;
  const calendarURL = process.env.REACT_APP_OPDC_CALENDAR;
  const token = GetCookieToken("userToken");
  const user = GetCookieData("userData");
  const user_position = GetCookieData("userPosition");
  
  const user_gender = user?.user_title_name;

  document.title = "Dashboard | Flexible-Time";

  const [userInfo, setUserInfo] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentBudgetYear, setCurrentBudgetYear] = useState(CheckBudgetYear());
  const [activeTab, setActiveTab] = useState("1");
  const [sarabunDoc, setSarabunDoc] = useState(0);

  const { position, setPosition } = useGetPositionConText()
  const { positionSubAdmin, setPositionSubAdmin } = useGetPositionSubAdminConTextConText()

  useEffect(() => {
    const getUserInfo = async () => {
      try {
        const res = await axios.get(baseURL + "/api/users/info", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setUserInfo(res.data.result);
        // setPosition(res?.data?.result?.position)
        // setPositionSubAdmin(res?.data?.result?.positionSubAdmin)
      } catch (err) {
        console.error(err);
      }
    };
    getUserInfo();
    setTimeout(() => {
      setLoading(true);
    }, 1000);
  }, []);

  const toggle1 = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  const isMustEntryWork = (positionArr) => {
    if (
      positionArr?.find(
        (item) => item?.position_id >= 1 && item?.position_id <= 5 && item?.assign !== 1
      )
    )
      return false;
    else return true;
  };

  return (
    <div className="page-content">
      {!loading ? (
        <LoadingPage />
      ) : (
        <FadeIn>
          <Container fluid>
            <Breadcrumbs
              breadcrumbItem="Dashboard"
              title="หน้าหลัก"
              main={true}
            />
            <Row>
              <Col xxl={4} xl={12}>
                <Row>
                  <Col xxl={12}>
                    {
                      userInfo?.user_id ? <WelcomeComp
                        currentBudgetYear={currentBudgetYear}
                        userId={userInfo?.user_id}
                        name={userInfo?.user_name}
                        email={userInfo?.user_email}
                        picture={userInfo?.user_pic}
                        user_gender={user_gender}
                      /> : ''
                    }
                  </Col>
                  <Col>
                    {/* <ReactApexChart
                      options={options}
                      series={series}
                      type="radialBar"
                      width="500"
                    /> */}
                  </Col>
                  {isMustEntryWork(user_position) && (
                    <Col xxl={12}>
                      {/* <EntryWork user_id={user?.user_id} token={token} /> */}
                      <WorkEntry isFromDashboard={true} />
                    </Col>
                  )}
                </Row>
              </Col>
              <Col xxl={8}>
                <Row>
                  <Col xxl={12}>
                    <Card>
                      <CardBody>
                        <Nav
                          // tabs
                          pills
                          className="navtab-bg flex-sm-column flex-md-row"
                          fill
                        >
                          <NavItem>
                            <NavLink
                              style={{ cursor: "pointer" }}
                              className={classnames({
                                active: activeTab === "1",
                              })}
                              onClick={() => {
                                toggle1("1");
                              }}
                            >
                              <div className="d-flex justify-content-center h5 m-0">
                                <i className="fa-solid fa-books font-size-20 me-2"></i>
                                สารบรรณ
                                {sarabunDoc ? <Badge
                                  className="ms-2 text-primary py-1"
                                  color="light"
                                >
                                  {sarabunDoc}
                                </Badge> : ''}
                              </div>
                            </NavLink>
                          </NavItem>
                          <NavItem>
                            <NavLink
                              style={{ cursor: "pointer" }}
                              className={classnames({
                                active: activeTab === "2",
                              })}
                              onClick={() => {
                                toggle1("2");
                              }}
                            >
                              <div className="d-flex justify-content-center h5 m-0">
                                <i className="fa-solid fa-toolbox font-size-20 me-2"></i>
                                ทรัพยากรออนไลน์
                              </div>
                            </NavLink>
                          </NavItem>
                          <NavItem>
                            <NavLink
                              style={{ cursor: "pointer" }}
                              className={classnames({
                                active: activeTab === "3",
                              })}
                              onClick={() => {
                                toggle1("3");
                              }}
                            >
                              <div className="d-flex justify-content-center h5 m-0">
                                <i className="fa-solid fa-check-to-slot font-size-20 me-2"></i>
                                การจองออนไลน์
                              </div>
                            </NavLink>
                          </NavItem>
                        </Nav>
                        <TabContent activeTab={activeTab}>
                          <TabPane tabId="1">
                            <Sarabun setSarabunDoc={setSarabunDoc} />
                          </TabPane>
                          <TabPane tabId="2">
                            <ResorceOnline />
                          </TabPane>
                          <TabPane tabId="3">
                            <Reservation />
                          </TabPane>
                        </TabContent>
                      </CardBody>
                    </Card>
                  </Col>

                  <Col xxl={12}>
                    <Card>
                      <CardBody style={{}}>
                        <div
                          style={{
                            minHeight: "500px",
                            position: "relative",
                            overflow: "hidden",
                            width: "100%",
                            paddingTop: "56.25%",
                          }}
                        >
                          <iframe
                            style={{
                              position: "absolute",
                              top: 0,
                              left: 0,
                              bottom: 0,
                              right: 0,
                              width: "100%",
                              height: "100%",
                            }}
                            src={calendarURL}
                            title="Outlook Calendar"
                          ></iframe>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </Col>
              <Col xxl={3}>
                <Row>
                  <Col
                    xxl={12}
                    xl={6}
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    {/* <ReactApexChart
                      options={options}
                      series={series}
                      type="radialBar"
                      width="500"
                    /> */}
                    {/* <div style={{minHeight:"400px",display: "flex",alignItems: "center",}}>
                    <h4>อยู่ระหว่างการแก้ไข Chart</h4>
                    </div> */}
                  </Col>
                </Row>
              </Col>
            </Row>
          </Container>
        </FadeIn>
      )}
    </div>
  );
};

export default Dashboard;
